import React from 'react'
import { FaApple, FaGooglePlay, FaMobileAlt } from 'react-icons/fa'

const Download = () => {
  return (
    <section id="download" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-primary-600 to-primary-800 text-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <FaMobileAlt className="h-16 w-16 mx-auto mb-6 text-white/80" />
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            Ready to Upgrade Your Fishing Experience?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto text-white/90">
            Download AnglersAI today and join thousands of anglers who are measuring and tracking their catches like never before.
          </p>
          
          <div className="flex flex-col items-center gap-4 mb-8">
            <a
              href="https://apps.apple.com/us/app/fish-measure-pro/id6747051635"
              className="inline-flex items-center justify-center px-12 py-5 bg-white text-black rounded-xl hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl"
            >
              <FaApple className="mr-3 h-8 w-8" />
              <div className="text-left">
                <div className="text-sm font-medium">Download on the</div>
                <div className="text-xl font-bold">App Store</div>
              </div>
            </a>
            
            <div className="text-white/90 text-center">
              <p className="text-lg font-medium mb-2">Available exclusively on iPhone</p>
              <p className="text-sm">Requires iOS 18.2 or later</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Download